<template>
    <div class="pt-2 pb-3 px-3">
        <h6
            style="font-family: MainFontBold, sans-serif;
            font-size: 16px;
            color: #2A2A2A;">
            Product Images
        </h6>
        <b-row no-gutters>
            <b-col class="pr-1">
                <div id="dstore-main-inventory-image" class="border">
                    <template v-if="selected_image === null">
                        <img v-if="values[0].image !== ''" :src="values[0].image" alt="Product Image">
                    </template>
                    <template v-else>
                        <img v-if="values[selected_image].image !== ''" :src="values[selected_image].image" alt="Product Image">
                    </template>
                </div>
                <div id="main-add-image-container" class="add-image-container"
                    @click="openCroppa(origin)">
                    <div class="upload-icon rounded-circle border mx-auto mb-1">
                    </div>
                </div>
                <div id="inventory-images-container" class="pt-2 pb-2">
                    
                    <div v-for="(image, index) in values"
                        :key="index">
                        <div :class="{
                            border: !image.active,
                            'border-active': selected_image == index && image != ''
                        }">
                            <img v-if="image.image !== ''"
                                :src="image.image"
                                class="product-image"
                                alt="Product Image"
                                @click="setActiveImage(index)">
                            <img v-if="image.image !== '' && isRemovable()"
                                src="@/assets/images/actions/remove.svg"
                                alt="Remove Button"
                                :class="{
                                    'remove-button': image.image === '',
                                    'remove-button-with-image': image.image !== ''
                                }"
                                @click="origin == 'edit_product'
                                    ? removeImage({
                                        type: 'update',
                                        index: index,
                                        uuid: image.uuid
                                    })
                                    : removeImage(index)">
                        </div>
                    </div>
                    <div id="plus-image-container">

                    </div>
                </div>
            </b-col>
        </b-row>
        <b-form-group
            id="productImagesGroup"
            label-for="productImages"
            class="secondary-label"
            :invalid-feedback="errorMessage('product_images')"
            :state="isValid('product_images')">
        </b-form-group>
        <h6
            style="font-family: MainFontBold, sans-serif;
            font-size: 16px;
            color: #2A2A2A;">
            Additional Images(Optional)
        </h6>
        <div style="position: relative;">
            <div id="first-additional-inventory-image" class="border mb-2">
                <img v-if="firstAdditionalImage !== ''" :src="firstAdditionalImage" alt="First Additional Image">
            </div>
            <div class="additional-add-image-container additional-image-upload"
                @click="openCroppaAdditionalImage('first')">
                <div class="upload-icon rounded-circle border mx-auto mb-1">
                </div>
            </div>
        </div>
        <span class="image-size-recommendation d-block mb-2">Recommended Size (414 x 370 px)</span>
        <div style="position: relative;">
            <div id="second-additional-inventory-image" class="border mb-2">
                <img v-if="secondAdditionalImage !== ''" :src="secondAdditionalImage" alt="Second Additional Image">
            </div>
            <div class="additional-add-image-container additional-image-upload"
                @click="openCroppaAdditionalImage('second')">
                <div class="upload-icon rounded-circle border mx-auto mb-1">
                </div>
            </div>
        </div>
        <span class="image-size-recommendation mt-2">Recommended Size (414 x 370 px)</span>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "ProductImages",
    props: [
        "values",
        "origin",
        "firstAdditionalImage",
        "secondAdditionalImage"
    ],
    computed: {
        ...mapState("dstoreInventories", ["errors", "product_active_img"])
    },
    data() {
        return {
            selected_image: null
        };
    },
    methods: {
        errorMessage(field) {
            if (this.errors == null) {
                return "";
            }

            return this.errors[field];
        },

        isValid(field) {
            if (this.errors == null) {
                return false;
            }

            return this.errors[field] ? false : true;
        },

        openCroppa: function() {
            this.$store.commit("dstoreInventories/setModal", {
                type: "croppa",
                status: true,
                base64: null,
                additionalImage: null,
                origin: this.origin
            });
        },
        openCroppaAdditionalImage: function(additionalImageNumber) {
            // console.log(additionalImageNumber);
            this.$store.commit("dstoreInventories/setModal", {
                type: "croppa",
                status: true,
                base64: null,
                additionalImage: additionalImageNumber,
                origin: this.origin
            });
        },

        setActiveImage: function(index) {
            this.$store.commit("dstoreInventories/setActiveImage", index);
        },

        removeImage: function(image) {
            this.$emit("removeImage", image);
            if (image == this.product_active_img) {
                this.$store.commit("dstoreInventories/setActiveImage", null);
            } else {
                this.$store.commit("dstoreInventories/setActiveImage", 0);
            }
        },

        isRemovable: function() {
            let empty_images = this.values
                .map(image => {
                    return image;
                })
                .filter(image => image.image == "");

            return empty_images.length < 9 ? true : false;
        }
    },
    watch: {
        product_active_img: function(index) {
            this.selected_image = index;
        }
    }
};
</script>
